import { useState, useCallback } from 'react';
import { MessageExtraData, StoredMessage } from './types';


const STORAGE_KEY = "raca_p_recent_sent_messages";
const MAX_MESSAGES = 5;

export const useStoreRecentMessages = () => {
  // Initialize state directly from localStorage so it's available on first render
  const [recentMessages, setRecentMessages] = useState<StoredMessage[]>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      console.error('Failed to parse recent messages from local storage', e);
    }
    return [];
  });

  const store = useCallback((text: string, extra?: MessageExtraData) => {
    const newMessage: StoredMessage = {
      text,
      extra,
      timestamp: Date.now(),
    };

    setRecentMessages((prevMessages) => {
      // Prepend the new message and keep only the first 5
      const updatedMessages = [newMessage, ...prevMessages].slice(0, MAX_MESSAGES);
      
      // Sync to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedMessages));
      } catch (e) {
        console.error('Failed to save recent messages to local storage', e);
      }

      return updatedMessages;
    });
  }, []);

  return {
    recentMessages,
    store,
  };
};
